import { render } from "./xtx-checkbox.vue?vue&type=template&id=51080bd3&scoped=true"
import script from "./xtx-checkbox.vue?vue&type=script&lang=js"
export * from "./xtx-checkbox.vue?vue&type=script&lang=js"

import "./xtx-checkbox.vue?vue&type=style&index=0&id=51080bd3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51080bd3"]])

export default __exports__